export interface QdsChartSeries { id: string; label: string; color?: string; }
export interface QdsChartTooltip { title: string; lines: string[]; }

/** Identity-based, independent of series order, filtering, chart instance, and render history. */
export function chartSeriesColor(id: string): string {
  let hash = 2166136261;
  for (const character of id) hash = Math.imul(hash ^ character.codePointAt(0)!, 16777619);
  const palette = [
    'var(--qds-chart-series-1, var(--theme-accent-primary, #445E89))',
    'var(--qds-chart-series-2, var(--theme-success, #00BE34))',
    'var(--qds-chart-series-3, var(--theme-warning, #FFA300))',
    'var(--qds-chart-series-4, var(--theme-error, #8B1F00))',
    'var(--qds-chart-series-5, var(--theme-accent-secondary, #3E495B))',
    'var(--qds-chart-series-6, var(--theme-text-secondary, #6C6C6C))',
  ];
  return palette[(hash >>> 0) % palette.length];
}

export function chartColor(series: QdsChartSeries): string { return series.color || chartSeriesColor(series.id); }

export function chartSeries(input: readonly QdsChartSeries[]): QdsChartSeries[] {
  if (!Array.isArray(input)) throw new Error('Series must be an array.');
  const ids = new Set<string>();
  return input.map(item => {
    if (!item || typeof item.id !== 'string' || !item.id || typeof item.label !== 'string' || !item.label || ids.has(item.id))
      throw new Error('Series need unique, nonempty IDs and labels.');
    if (item.color !== undefined && typeof item.color !== 'string') throw new Error('Series colors must be CSS color strings.');
    ids.add(item.id); return { id: item.id, label: item.label, ...(item.color ? { color: item.color } : {}) };
  });
}
